import { useEffect, useState } from "react";
import userPic1 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/1.webp";
import userPic2 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/2.webp";
import userPic3 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/3.webp";
import userPic4 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/4.webp";
import userPic5 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/5.webp";
import userPic6 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/6.webp";
import userPic7 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/7.webp";
import userPic8 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/8.webp";
import userPic9 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/9.webp";
import userPic10 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/10.webp";
import userPic11 from "../../../../../public/assets/newEvent/pujaDetails/reviewUserDp/11.webp";
import Image from "next/image";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import style from "../../../styles/pujaDetails.module.css";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import theme from "src/globalModule/styles/theme";
function UserListPujaAB({
  eventData,
  handleToReviews
}) {
  const {
    t
  } = useTranslation();
  const [userDp, setUserDp] = useState([]);
  const [textForUser, setTextForUser] = useState("");
  useEffect(() => {
    setTextForUser(eventData.realParticipantNo > 3 ? "+" + (eventData.realParticipantNo - 3) : "+" + Math.floor(Math.random() * 90) + 10);
    let dpArray = [{
      id: 1,
      dp: userPic1
    }, {
      id: 2,
      dp: userPic2
    }, {
      id: 3,
      dp: userPic3
    }, {
      id: 4,
      dp: userPic4
    }, {
      id: 5,
      dp: userPic5
    }, {
      id: 6,
      dp: userPic6
    }, {
      id: 7,
      dp: userPic7
    }, {
      id: 8,
      dp: userPic8
    }, {
      id: 9,
      dp: userPic9
    }, {
      id: 10,
      dp: userPic10
    }, {
      id: 11,
      dp: userPic11
    }];
    dpArray = dpArray.sort(() => Math.random() - 0.5).slice(0, 4);
    setUserDp(dpArray);
  }, [eventData]);
  return <div className={style.userListContainer} onClick={handleToReviews} data-sentry-component="UserListPujaAB" data-sentry-source-file="UserListPuja.jsx">
      <>
        <Stack direction={"row"} data-sentry-element="Stack" data-sentry-source-file="UserListPuja.jsx">
          {userDp.map((e, index) => <div key={index} className={style.userDpAB}>
              <Image src={e?.dp || defaultProfilePic} alt={t("noimg")} width={"35"} height={"35"} style={{
            objectFit: "cover"
          }}
          // placeholder="blur"
          loading="lazy"
          // blurDataURL={e?.dp}
          />
            </div>)}
        </Stack>

        <div>
          <Typography fontSize={"15px"} sx={{
          // color: theme.palette.common.darkOrange,
          background: "linear-gradient(90deg, #FF9800 0%, #FF5757 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: 600,
          fontFamily: "Poppins"
        }} data-sentry-element="Typography" data-sentry-source-file="UserListPuja.jsx">
            {t("1-lakh-devotees")}
          </Typography>
          <Typography sx={{
          fontSize: "14px",
          color: theme.palette.text.secondaryDark,
          margin: "-2px 0 0 0"
        }} data-sentry-element="Typography" data-sentry-source-file="UserListPuja.jsx">
            {t("have-offer-puja-with-utsav")}
          </Typography>
        </div>
      </>
    </div>;
}
export default UserListPujaAB;